import * as React from 'react'
import styles from './UIButton.module.less'
import { Button } from 'antd'
import { ButtonType } from 'antd/es/button'
import { DataTestId } from 'src/constants/ui.constants'

export type UIButtonProps = {
    title: string
    icon?: string
    iconPosition?: 'start' | 'end'
    type?: ButtonType | 'tag'
    width?: string
    onClick?: () => void | Promise<void>
    className?: string
    isDisabled?: boolean
    buttonStyle?: React.CSSProperties
    htmlType?: 'button' | 'submit' | 'reset'
    isLoading?: boolean
}

export const UIButton: React.FC<UIButtonProps> = props => {
    if (!props.title) {
        return null
    }

    const buttonType = props.type === 'tag' ? 'default' : props.type

    const buttonClassName = [
        styles.uiButton,
        props.className,
        props.type === 'tag' ? styles.BtnTag : '',
    ]
        .filter(Boolean)
        .join(' ')

    return (
        <Button
            className={buttonClassName}
            type={buttonType}
            style={{ width: props.width, ...props.buttonStyle }}
            icon={props.icon && <img src={props.icon} alt={props.title} />}
            disabled={props.isDisabled}
            onClick={props.onClick}
            iconPosition={props.iconPosition}
            htmlType={props.htmlType}
            loading={props.isLoading}
            data-testid={DataTestId.UIButton}
        >
            {props.title}
        </Button>
    )
}
